import React from 'react';

export default function MatriculaOnline() {
	return (
		<div className="alert border">
			<h5 className="text-center mb-3">ATENÇÃO ALUNO:</h5>
			<b>
				A ficha é individual por curso,
				caso queira matricular-se em mais de um curso favor preencher uma ficha por curso.
			</b>
			<br />
			<br />
			<p className="text-start" style={{ lineHeight: '30px' }}>
				<b>-</b>
				&nbsp;
				Após o envio da ficha é obrigatório efetuar o pagamento da matrícula
				do curso no mesmo dia ou sua ficha será invalidada.
				<br />
				<b>-</b>
				&nbsp;
				Matrículas realizadas um dia antes do Curso não terá isenção de matrícula.
				<br />
				<b>-</b>
				&nbsp;
				Apenas é isento da taxa de matricula de (Cursos R$ 120,00 / Pós-Graduação R$150,00) o aluno que efetuar o pagamento
				integral do curso à vista ou a prazo. Caso vc não efetue e preencha nova ficha
				para o mesmo curso, não haverá mais a possibilidade de isenção de matricula.
				<br />
				<b>-</b>
				&nbsp;
				Em caso de promoções veiculadas em redes sociais fica valendo as regras da
				mesma em caráter especial.
				<br />
				<b>-</b>
				&nbsp;
				Taxa de matrícula: o aluno paga a taxa de matrícula quando não vai realizar de imediato o pagamento do curso.
				Essa taxa não é abatida do valor do curso, que deve ser pago 5 dias antes da realização do mesmo.
				Valor da taxa: (Cursos R$ 120,00 / Pós-Graduação R$150,00). Não devolvemos a taxa em caso de desistência.
				<br />
				{/* <b>-</b>
				&nbsp;
				O aluno pode realizar o pagamento de 50% do valor do curso no ato da matrícula
				e ficar isento da taxa de matrícula, devendo pagar o restante 5 dias antes da realização do mesmo.
				A desistência acarreta desconto de 25% do valor pago, referente à taxa de reserva de vaga,
				devido à impossibilidade de incluir outro aluno até o momento da desistência.
				<br /> */}
				{/* <b>-</b>
				&nbsp;
				O aluno pode pagar o valor total do curso no ato da matrícula,
				ganhando assim um desconto automático de 15% no pagamento à vista e 10% no pagamento a prazo,
				não sendo cobrada taxa de matrícula.
				A desistência acarreta desconto de 25% do valor pago, referente à taxa de reserva de vaga,
				devido à impossibilidade de incluir outro aluno até o momento da desistência.
				<br /> */}
				Obs.: Ao se esgotarem as vagas para cada curso, o mesmo será avisado na coluna de
				datas de cursos.
			</p>
		</div>
	);
}
